import BaseApi from 'core/api/BaseApi';

import { denormalizeData } from 'core/utils/api';

/**
 * API описано по сваггер схеме
 * http://s2.bebop.unity.rambler.tech:8087/?url=https://s1.secretmag.ru/ugc/api/v1/swagger.json
 */
export default class Ugc extends BaseApi {
  constructor() {
    super();

    this.client.defaults.headers.get['Content-Type'] = 'application/json';

    this.client.interceptors.response.use(
      response => denormalizeData(this.getData(response)),
      this.authErrorInterceptor
    );
  }

  /**
   * Существующая проблема:
   * Запросы к UGC API, требуют ключа авторизации rsidx, который лежит в API другого сервиса
   * window.ramblerIdHelper.getSessionToken.
   * Перед запросом к апишке UGC, нужно получить этот токен.
   * Описывать такое поведение для каждой ручки неудобно.
   *
   * Алгоритм позволяет прервать текущий запрос (statusCode === 401), запросить токен,
   * повторить основной запрос и вернуть результат в data resolver.
   *
   * По мотивам этого треда:
   * https://stackoverflow.com/questions/61347944/reactjs-watch-access-token-expiration
   */
  authErrorInterceptor = async error => {
    let errorConfig = error.config;
    const isUnAuthorized = error.response && error.response.status === 401;

    if (isUnAuthorized) {
      await new Promise(resolve => {
        window.ramblerIdHelper.getSessionToken(({ token }) => {
          // устанавливаем токен для текущего запроса
          errorConfig = {
            ...errorConfig,
            headers: { ...errorConfig.headers, rsidx: token },
          };

          // устанавливаем токен для последующих запросов
          this.client.defaults.headers.rsidx = token;

          resolve(token);
        });
      });

      return this.client(errorConfig);
    }

    return Promise.reject(error);
  };

  getTopics = params => {
    return this.client({
      method: 'get',
      url: '/topics',
      params,
    });
  };

  createTopic = data => {
    return this.client({
      method: 'post',
      url: '/topics',
      data,
    });
  };

  getTopicByid = params => {
    return this.client({
      method: 'get',
      url: `/topics/${params.uuid}`,
      params,
    });
  };

  updateOneTopic = data => {
    return this.client({
      method: 'put',
      url: `/topics/${data.uuid}`,
      data,
    });
  };

  destroyOneTopic = params => {
    return this.client({
      method: 'delete',
      url: `/topics/${params.uuid}`,
      params,
    });
  };

  submitTopicByid = params => {
    return this.client({
      method: 'post',
      url: `/topics/${params.uuid}/submit`,
      params,
    });
  };

  withdrawTopicByid = params => {
    return this.client({
      method: 'post',
      url: `/topics/${params.uuid}/withdraw`,
      params,
    });
  };

  getAssets = () => {
    return this.client.get('/assets');
  };

  createAsset = data => {
    return this.client({
      method: 'post',
      headers: {
        ['Content-Type']: 'multipart/form-data',
      },
      url: '/assets',
      data,
    });
  };

  getAssetByid = ({ uuid }) => {
    return this.client.get(`/assets/${uuid}`);
  };

  getAuthor = params => {
    return this.client({
      method: 'get',
      url: '/author',
      params,
    });
  };

  updateOneAuthor = data => {
    return this.client({
      method: 'put',
      url: '/author',
      data,
    });
  };

  getSettings = () => {
    return this.client.get('/settings');
  };

  updateOneSettings = data => {
    return this.client({
      method: 'put',
      url: '/settings',
      data,
    });
  };
}

export const ugc = new Ugc();
